// Checkout
export const UPDATE_SHIPMENT = 'UPDATE_SHIPMENT';
export const SET_CLIENT_INPUT_MODE = 'SET_CLIENT_INPUT_MODE';
export const SET_FROM = 'SET_FROM';
export const SET_LABEL = 'SET_LABEL';
export const SET_TO = 'SET_TO';
export const SET_IN_POST_LOCKERS = 'SET_IN_POST_LOCKERS';
export const SET_SERVICE = 'SET_SERVICE';
export const SET_PRICE_DETAILS = 'SET_PRICE_DETAILS';
export const SET_PACKAGES = 'SET_PACKAGES';
export const SET_COLLECTION = 'SET_COLLECTION';
export const SET_COLLECTION_DATE = 'SET_COLLECTION_DATE';
export const SET_COLLECTION_INTERVAL = 'SET_COLLECTION_INTERVAL';
export const REMOVE_VOUCHER = 'REMOVE_VOUCHER';
export const SET_DROPOFF_ID = 'SET_DROPOFF_ID';
export const SET_SERVICES_TAB = 'SET_SERVICES_TAB';

// Status
export const SET_ERROR = 'SET_ERROR';
export const SET_LOADING = 'SET_LOADING';
export const SET_FORM_SUBMITTED = 'SET_FORM_SUBMITTED';
export const SET_DEFAULT_COUNTRY = 'SET_DEFAULT_COUNTRY';
export const SET_SCROLL_TO_ERROR = 'SET_SCROLL_TO_ERROR';

// Payment
export const DELETE_PAYMENT_CLIENT_METHOD = 'DELETE_PAYMENT_CLIENT_METHOD';
export const SET_PAYMENT_CLIENT_METHODS = 'SET_PAYMENT_CLIENT_METHODS';

// Promo Code
export const SET_VOUCHER = 'SET_VOUCHER';

// Printing
export const CHANGE_PRINTING_FORMAT = 'CHANGE_PRINTING_FORMAT';

// Upsell
export const SET_UPSELL_OPTIONS = 'SET_UPSELL_OPTIONS';
export const TOGGLE_UPSELL = 'TOGGLE_UPSELL';
export const CLEAR_SELECTED_UPSELLS = 'CLEAR_SELECTED_UPSELLS';

// Client
export const SET_CLIENT = 'SET_CLIENT';

// User
export const SET_USER = 'SET_USER';

// Carriers Terms and Conditions
export const SET_CARRIERS_TERMS_AND_CONDITIONS = 'SET_CARRIERS_TERMS_AND_CONDITIONS';

// Languages
export const SET_AVAILABLE_LANGUAGES = 'SET_AVAILABLE_LANGUAGES';
export const SET_LOCALE = 'SET_LOCALE';
